<template src="./index.html">
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex'
import { jump, getUrlParam } from '../../util/jumpPage'

export default {
  name: 'headerBox',
  data(){
    return {
			loginStatus: false,
			loadLogined:false,
			showLoginOutStatus:false,
			userName:''
    }
  },
  computed: {
    ...mapState('commonData', {
      currentPage: s => s.currentPage
    })
  },
  mounted(){
		this.loadLogin()
  },
  methods: {
		...mapActions('dataLogin', ['getLogin','loginOut']),
		go_page(page){
			jump(this, {
				page,
				deep:true
			})
		},
		jumpToLoginUrl () {
				window.location.href = "https://cloud.tencent.com/login?s_url="+encodeURIComponent(window.location.href)
		},
		jumpToRegisterUrl () {
			window.location.href = 'https://cloud.tencent.com/register?s_url=' + encodeURIComponent(window.location.href)
		},
		show_loginout_float(){
			this.showLoginOutStatus = true
		},
		hide_loginout_float(){
			this.showLoginOutStatus = false
		},
		async loadLogin () {
			let logRet = await this.getLogin()

			this.loadLogined = true
			if(logRet && logRet.userInfo){
				this.loginStatus = true
				this.userName = logRet.userInfo.nickname
			}else{
				this.loginStatus = false
			}

		},
		async login_out(){
			this.loginOut().then(()=>{
				window.location.href = "https://cloud.tencent.com/login?s_url="+encodeURIComponent(window.location.href)
			},()=>{})
		}
  }
}
</script>

<style scoped src="./index.less" lang="less">
</style>
